import { render, staticRenderFns } from "./AccessToNoAccount.vue?vue&type=template&id=0a191f7d"
import script from "./AccessToNoAccount.vue?vue&type=script&lang=js"
export * from "./AccessToNoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports